import { z } from 'zod';

export const PACKAGE = '@dcs/contracts';

/** Placeholder schema; real contracts land in F1+. */
export const packageNameSchema = z.string().startsWith('@dcs/');

export * from './usage.ts';
export * from './stats.ts';
export * from './me.ts';
export * from './attempt.ts';
export * from './progress.ts';
export * from './account.ts';
export * from './report.ts';
export * from './client-errors.ts';
export * from './post.ts';
export * from './rich-text.ts';
